import config from '../../services/config';

const INITIAL_STATE = config;

export default function sistema(state = INITIAL_STATE, action) {
  return state;
}
